import React, {useEffect, useState} from 'react';
import styled from 'styled-components';

const ButtonToTop = ({visible, onPress}) => {
    //const bottomPadding = useSharedValue(-64);

    const [bottomPadding, setBottomPadding] = useState(-64);
    useEffect(() => {
        if (visible) {
            //bottomPadding.value = withTiming(20);
            setBottomPadding(20);
        } else {
            //bottomPadding.value = withTiming(-64);
            setBottomPadding(-64);
        }
    }, [visible, bottomPadding]);

    return (
        <Container bottomPadding={bottomPadding} onClick={onPress}>
            <Image
                src={require('../../../assets/ic_arrow_up.png')}
                alt="Back"
            />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    position: absolute;
    width: 64px;
    height: 64px;
    border-radius: 32px;
    right: 20px;
    background-color: green;
    overflow: hidden;
    background: linear-gradient(90deg, #f55a61 0%, #ec098c 100%);
    bottom: ${props => props.bottomPadding}px;
    transition: bottom 0.3s ease-in-out;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

const Image = styled.img`
    object-fit: center;
    width: 18px;
    height: 21px;
`;

export default ButtonToTop;
